import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 bookingList:[],
 getdashboardData:[],
 getReport:[],
 getAddress:[],
 getStatistical:[],
 getRatingList:[],
 getCategoresList:[],
 getOffersList:[],
 getDriversList:[],
 getUsersList:[],
 getSingleBooking:[],
 getWishlist:[],
 getwishFilter:[],
 getReportDownload:[],
 getFinancialDownload:[]
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setGetBookingList: (state, action) => {
      state.bookingList = action.payload;
    },
    setGetDashboard: (state, action) => {
      state.getdashboardData = action.payload;
    },
    setGetReports: (state, action) => {
      state.getReport = action.payload;
    },
    seGetAddress: (state, action) => {
      state.getAddress = action.payload;
    },
    setGetStatistical: (state, action) => {
      state.getStatistical = action.payload;
    },
    setGetRatingList: (state, action) => {
      state.getRatingList = action.payload;
    },
    setGetCategoresList: (state, action) => {
      state.getCategoresList = action.payload;
    },
    setGetOffersList: (state, action) => {
      state.getOffersList = action.payload;
    },
    setGetDriversList: (state, action) => {
      state.getDriversList = action.payload;
    },
    setUsersList: (state, action) => {
      state.getUsersList = action.payload;
    },
    setGetSingleBookingdata: (state, action) => {
      state.getSingleBooking = action.payload;
    },
    setgetWishList: (state, action) => {
      state.getWishlist = action.payload;
    },
    setGetWishFilter: (state, action) => {
      state.getwishFilter = action.payload;
    },
    setGetStatisticalReportDownload: (state, action) => {
      state.getReportDownload = action.payload;
    },
    setGetFinancialReportDownload: (state, action) => {
      state.getFinancialDownload = action.payload;
    },
  },
});

export const {setGetFinancialReportDownload,setGetStatisticalReportDownload,setGetWishFilter, setgetWishList,setGetSingleBookingdata,setUsersList,setGetDriversList,setGetBookingList,setGetDashboard,setGetReports,seGetAddress,setGetStatistical,setGetRatingList,setGetCategoresList,setGetOffersList } = bookingSlice?.actions;
